const setFromDomEvent = (setter, { target: { value } }) => setter(value);

export { setFromDomEvent };
